import React from 'react'
import { connect } from 'react-redux'

import { hideModal } from '../ModalRoot/actions'
import Modal from '../../elements/Modal'

const Confirmation = props => {
  const handleConfirm = () => {
    if (props.onConfirm) {
      props.onConfirm()
    }
    props.hideModal()
  }

  return (
    <Modal
      description={props.modalDescription}
      image={props.image}
      hideModal={props.hideModal}
      onConfirm={() => handleConfirm()}
      title={props.modalTitle}
      accountType={props.accountType}
      confirmButtonLabel={props.confirmButtonLabel}
    />
  )
}

export default connect(null, { hideModal })(Confirmation)



// WEBPACK FOOTER //
// ./src/app/modules/ConfirmationModal/index.js